import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AdminToolbar from '../Toolbar/AdminToolbar';
import EditorToolbar from '../Toolbar/EditorToolbar';
import EventDetails from './EventDetails';
import EventDetailsEdit from './EventDetailsEdit';
import EventDetailsViewUser from '../../User/userPostView';
import NMH_LOGO_White_RGB from '../../Assets/NMH_LOGO_White_RGB.png';
import { Box,Typography, AppBar, Toolbar,ListItem, ListItemText, MenuItem } from '@mui/material';
import EventDetailsViewGuest from './EventDetailsGuest';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EventDetailsWrapper = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState(null);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserFromCookie = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });

        const { user, username,isLoggedIn } = res.data;
        if (username && (user === 'Admin' || user === 'Editor' || user === 'User')) {
          setUserType(user);
          setUsername(username);
        }
        else if((username)&& !isLoggedIn)
        {
            setUserType('User');
        }
         else {
          setUserType('Guest');
        }
      } catch (err) {
        console.error('Error checking login:', err);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    getUserFromCookie();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;
 const HeaderOffset = () => (
  <Toolbar sx={{ minHeight: { xs: 200, sm: 80, lg: 70 } }} />
);
  return (
    <>
     
      {userType === 'Admin' && (
            <>
           
             <EventDetailsEdit/>
            </>
          )}
      {userType === 'Editor' && (
            <>
            <EventDetails/>
            </>
          )}
             {(userType === 'User' ) && (
                 <EventDetailsViewUser />
             )}
              {(userType === 'Guest' ) && (
                    <>    
              <AppBar position="fixed" className="app-bar"   sx={{ backgroundColor: '#002855', color: 'white',
                     height: {  
                      //  xs: '200px',  
                     sm: '80px',   lg: '70px', },}}>
                <Toolbar>
                    <img src={NMH_LOGO_White_RGB} className="toolbar-logo" alt="NMH Logo" />
                   <Typography  className="title"   sx={{ fontSize: '1.1rem', fontWeight: 'bold', textAlign: 'center' }} >Opportunities Beyond Campus</Typography>
                  <Box className="user-section">
                  <MenuItem button onClick={() => navigate("/login")}>
                    <ListItemText primary="Login" sx={{ color: "white" }} />
                </MenuItem>
                  </Box>
               </Toolbar>
              </AppBar>
              <HeaderOffset/>
                 <EventDetailsViewGuest />
                 </>
             )}
   
    </>
  );
};

export default EventDetailsWrapper;
